import { atom, useAtom } from "jotai";

export const showTradePanelAtom = atom<boolean>(false);

export const useShowTradePanel = () => {
  const [showTradePanel, setShowTradePanel] = useAtom(showTradePanelAtom);

  return {
    showTradePanel,
    setShowTradePanel,
  };
};
